var map = {
	"./deflag.svg": 8155,
	"./enflag.svg": 9505,
	"./esflag.svg": 5470,
	"./frflag.svg": 4528,
	"./itflag.svg": 2144,
	"./ruflag.svg": 2366,
	"./trflag.svg": 5567
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4860;